module.exports = __webpack_public_path__ + "img/gedung-utama.ed899335.jpg";